axios.get(DoublyGlobal.ratesUrl)
.then(response =>{
	let DoublyCurrency
	if(response.status == 200){
		eval(response.data)

		store.state.currency.rates = Currency
	}

})

function setCookie(name,value,days) {
	var expires = "";
	if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

setTimeout(() => {
	
	const optionsCurrency = document.querySelectorAll('.doubly-nice-select .option')
	optionsCurrency.forEach(x =>x.addEventListener("click", (event) => {
	
		let currency = event.target.getAttribute('data-value')


		store.state.currency.current = currency
		
		setCookie('currencyCookie',btoa(currency),null)
		setCookie(DoublyGlobal.cookieName,btoa(currency),null)
		setCookie('MXN',true,null)

	}))

	const optionsCountry = document.querySelectorAll('#country_code option')
	
	optionsCountry.forEach(x =>{
		x.innerHTML = x.innerHTML.split(' (')[0]

	})


	
}, 1000);

const CurrencyOptions = {
	store,
	name: 'CurrencyApp',
	delimiters: ['${', '}'],
	compilerOptions:{ 
			isCustomElement: tag => ['quantity-input', 'cart-remove-button'].includes(tag)
	},
	data() {

			return {
					currency: store.state.currency
			}

	},
	computed: {
			currentEspecialista(){
					if(!store.state.customer.address){

							return {}
					}
			}
	},
	created() {

	},
	methods:{

			
	}

}

const CurrencyApp = Vue.createApp(CurrencyOptions)


const initCurrencyApp = () => {
	CurrencyApp.mount('#CurrencyApp')
}

initCurrencyApp()
CurrencyApp.use(store)

/* WU: sin sufijo " MXN" en precios — la app Doubly reescribe los <span class=money>
   agregando el código de moneda; aquí se limpia SOLO cuando es MXN (otras divisas
   conservan su código, que ahí sí informa). Barrido debounced por rAF: al limpiar,
   el texto deja de matchear y el observer se asienta solo. */
;(function(){
	var scheduled = false;
	function sweep(){
		scheduled = false;
		document.querySelectorAll('span.money').forEach(function(el){
			if (/\bMXN\b/.test(el.textContent)) el.textContent = el.textContent.replace(/\s*MXN\b/g, '');
		});
	}
	function schedule(){ if (!scheduled){ scheduled = true; requestAnimationFrame(sweep); } }
	new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
	if (document.readyState !== 'loading') schedule();
	else document.addEventListener('DOMContentLoaded', schedule);
})();